const SKILL_NAMES: Record<string, string> = {
	SK01: "订单列表定位",
	SK02: "订单详情聚合",
	SK03: "商品详情获取",
	SK04: "商品推荐",
	SK05: "知识检索",
	SK06: "优惠规则查询",
	SK07: "取消订单",
	SK08: "退货创建",
	SK09: "退款执行",
	SK10: "修改地址",
	SK11: "转人工",
};

const SKILL_TAOBAO_COVERAGE: Record<string, string> = {
	SK01: "订单定位 / 多订单选择",
	SK02: "物流跟踪 / 退款取消辅证",
	SK03: "商品详情 / 变体 / 对比证据",
	SK04: "商品推荐 / 找同款 / 库存替代",
	SK05: "政策知识 / 平台知识检索",
	SK06: "省钱优惠 / 适用规则",
	SK07: "取消订单 / 写操作保护",
	SK08: "退货创建 / 写操作保护",
	SK09: "退款执行 / 写操作保护",
	SK10: "地址修改 / 写操作保护",
	SK11: "转人工 / 上下文交接",
};

const INTENT_NAMES: Record<string, string> = {
	order_status_inquiry: "订单状态查询",
	shipping_tracking: "物流跟踪",
	order_issue: "订单异常",
	refund_request: "退款申请",
	return_request: "退货申请",
	order_cancel: "取消订单",
	address_change: "修改地址",
	product_inquiry: "商品咨询",
	product_recommendation: "商品推荐",
	knowledge_qa: "政策知识问答",
	discount_inquiry: "优惠咨询",
	discount_code: "优惠码咨询",
	human_handoff: "转人工",
	greeting: "问候闲聊",
	unknown: "未识别",
};

const PLAYBOOK_NAMES: Record<string, string> = {
	PB01_order_query: "订单查询方案",
	PB02_refund: "退款办理方案",
	PB03_return: "退货办理方案",
	PB04_cancel: "取消订单方案",
	PB05_address_change: "地址修改方案",
	PB06_pre_sale: "售前导购方案",
	PB07_discount: "优惠咨询方案",
};

const SAMPLE_NAMES: Record<string, string> = {
	P10TA001: "退款申请缺少订单号",
	P10TA002: "退款进度查询",
	P10TA003: "店铺商品咨询",
	P10TA004: "商品推荐与对比",
	P10TA005: "退货政策知识检索",
	P10TA006: "优惠码可用性检查",
	P10TA007: "取消订单保护验证",
	P10TA008: "退款执行保护验证",
	P10TA009: "修改地址保护验证",
	P10TA010: "取消订单 dry-run 验证",
	P11TA011: "订单异常缺少订单信息",
	custom_input: "自定义问题",
};

const SERVICE_STAGE_NAMES: Record<string, string> = {
	pre_sale: "售前",
	in_sale: "售中",
	after_sale: "售后",
	unknown: "未识别阶段",
};

// T1 match_tags · order_status 维（MVP 仅 fulfillment 一层）
const ORDER_STATUS_NAMES: Record<string, string> = {
	UNFULFILLED: "未发货",
	PARTIAL: "部分发货",
	FULFILLED: "已发货",
};

// T1 match_tags · dialogue_state 维
const DIALOGUE_STATE_NAMES: Record<string, string> = {
	clarify: "待澄清",
	actionable: "可执行",
	handoff: "转人工",
};

// T1 match_tags 五维的维度名中文
const MATCH_TAG_DIM_LABELS: Record<string, string> = {
	intent_tags: "意图",
	product_tags: "商品",
	sale_stage: "销售阶段",
	order_status: "订单状态",
	dialogue_state: "对话状态",
};

const INTENT_RULE_NAMES: Record<string, string> = {
	R001: "转人工快路径",
	R002: "取消订单快路径",
	R003: "订单状态快路径",
	R004: "问候感谢兜底快路径",
	R012_refund: "退款配置规则",
	R051_handoff: "转人工配置规则",
	T002: "退款评测规则",
};

const EVENT_NAMES: Record<string, string> = {
	generation_completed: "回复生成完成",
	quality_completed: "质量检查完成",
	context_loaded: "上下文加载完成",
	intent_classified: "意图识别完成",
	playbook_selected: "方案选择完成",
	tool_executed: "工具执行完成",
	knowledge_retrieved: "知识检索完成",
};

const TARGET_STAGE_NAMES: Record<string, string> = {
	intent_classification: "意图分类",
	playbook_routing: "处理方案",
	tool_and_evidence: "工具与证据",
	knowledge_retrieval: "知识检索",
	prompt_response: "回复生成",
	quality_guard: "质量策略",
};

const QUALITY_DECISION_NAMES: Record<string, string> = {
	pass: "放行",
	passed: "放行",
	success: "通过",
	revise: "需改写",
	rewrite: "需改写",
	block: "阻断",
	blocked: "阻断",
	handoff: "转人工",
	manual_review: "人工复核",
};

const FINAL_ACTION_NAMES: Record<string, string> = {
	reply: "回复客户",
	answer: "回复客户",
	clarify: "继续追问",
	commit_action: "执行受控动作",
	handoff: "转人工",
	no_action: "不执行动作",
};

const KNOWLEDGE_SOURCE_NAMES: Record<string, string> = {
	mock: "模拟知识库",
	fixture: "模拟数据",
	vector: "向量检索",
	hybrid: "混合检索",
	live: "线上知识库",
	unknown: "未识别来源",
};

const MATCH_MODE_NAMES: Record<string, string> = {
	routing_table: "RoutingTable 命中",
	short_circuit: "短路径命中",
	config_mapping: "兜底映射命中",
	vector: "语义兜底命中",
	no_match: "未命中",
	skipped: "延续上轮方案",
	tag_match: "标签召回命中",
};

export function skillLabel(skillId?: string): string {
	const id = skillId ?? "SK05";
	const name = SKILL_NAMES[id];
	return name ? `${name}（${id}）` : id;
}

export function skillListLabel(skillIds: string[]): string {
	if (skillIds.length === 0) return "无";
	return skillIds.map((skillId) => skillLabel(skillId)).join("、");
}

export function skillTaobaoCoverage(skillId?: string): string {
	if (!skillId) return "未登记";
	return SKILL_TAOBAO_COVERAGE[skillId] ?? "未登记";
}

export function intentLabel(intent?: string | null): string {
	return labeledCode(intent, INTENT_NAMES);
}

export function playbookLabel(playbookId?: string | null): string {
	const value = normalizeValue(playbookId);
	if (!value) return "未返回";
	if (value === "无方案命中" || value === "通用兜底") return value;
	return labeledCode(value, PLAYBOOK_NAMES);
}

export function sampleLabel(sampleId?: string | null): string {
	return labeledCode(sampleId, SAMPLE_NAMES);
}

export function serviceStageLabel(stage?: string | null): string {
	return labeledCode(stage, SERVICE_STAGE_NAMES);
}

export function orderStatusLabel(status?: string | null): string {
	return labeledCode(status, ORDER_STATUS_NAMES);
}

export function dialogueStateLabel(state?: string | null): string {
	return labeledCode(state, DIALOGUE_STATE_NAMES);
}

export function matchTagDimLabel(dim: string): string {
	return MATCH_TAG_DIM_LABELS[dim] ?? dim;
}

/** match_tags 单个取值 → 中文（按维度路由到对应词表）· "*" = 不限 */
export function matchTagValueLabel(dim: string, value: string): string {
	if (value === "*") return "不限";
	switch (dim) {
		case "intent_tags":
			return intentLabel(value);
		case "sale_stage":
			return serviceStageLabel(value);
		case "order_status":
			return orderStatusLabel(value);
		case "dialogue_state":
			return dialogueStateLabel(value);
		default:
			return value; // product_tags 等：原值
	}
}

export function intentRuleLabel(ruleId?: string | null): string {
	const value = normalizeValue(ruleId);
	if (!value || value === "未命中 L2 规则" || value === "—") return "未命中 L2 规则";
	return labeledCode(value, INTENT_RULE_NAMES);
}

export function eventLabel(eventType?: string | null): string {
	return labeledCode(eventType, EVENT_NAMES);
}

export function targetStageLabel(stage?: string | null): string {
	return labeledCode(stage, TARGET_STAGE_NAMES);
}

export function qualityDecisionLabel(decision?: string | null): string {
	return labeledByNormalizedCode(decision, QUALITY_DECISION_NAMES);
}

export function finalActionLabel(action?: string | null): string {
	return labeledByNormalizedCode(action, FINAL_ACTION_NAMES);
}

export function knowledgeSourceLabel(source?: string | null): string {
	return labeledCode(source, KNOWLEDGE_SOURCE_NAMES);
}

export function matchModeLabel(mode?: string | null): string {
	return labeledCode(mode, MATCH_MODE_NAMES);
}

function labeledByNormalizedCode(
	value: string | null | undefined,
	labels: Record<string, string>,
): string {
	const normalized = normalizeValue(value);
	if (!normalized) return "未返回";
	if (alreadyLabeled(normalized)) return normalized;
	const label = labels[normalized.toLowerCase()];
	return label ? `${label}（${normalized}）` : normalized;
}

function labeledCode(value: string | null | undefined, labels: Record<string, string>): string {
	const normalized = normalizeValue(value);
	if (!normalized) return "未返回";
	if (alreadyLabeled(normalized)) return normalized;
	const label = labels[normalized];
	return label ? `${label}（${normalized}）` : normalized;
}

function normalizeValue(value: string | null | undefined): string {
	return value?.trim() ?? "";
}

function alreadyLabeled(value: string): boolean {
	return value.includes("（") && value.includes("）");
}
